function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M16.828,22.429l-4.588,1.229c-0.56,0.15-0.893,0.73-0.741,1.293c0.147,0.552,0.726,0.888,1.285,0.738 l4.588-1.23c0.564-0.15,0.894-0.729,0.746-1.281C17.967,22.615,17.392,22.277,16.828,22.429z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M20.958,16.777c-0.151-0.564-0.729-0.897-1.289-0.748l-8.838,2.369c-0.561,0.15-0.894,0.727-0.742,1.292 c0.15,0.561,0.728,0.894,1.287,0.744l8.838-2.369C20.774,17.915,21.108,17.337,20.958,16.777z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M19.56,11.559c-0.148-0.557-0.728-0.892-1.287-0.741l-8.839,2.368c-0.561,0.15-0.893,0.729-0.744,1.286 c0.15,0.559,0.727,0.892,1.287,0.742l8.839-2.368C19.376,12.694,19.71,12.118,19.56,11.559z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M36.101,35.172l-2.712-4.124l-0.019-0.003c1.702-1.467,2.787-3.631,2.787-6.051 c0-4.415-3.594-8.004-8.005-8.004c-0.387,0-0.764,0.037-1.135,0.09L23.912,5.491c-0.073-0.274-0.253-0.499-0.488-0.644 c0,0-7.951-4.542-8.258-4.709s-0.611-0.155-0.798-0.105S0.777,3.675,0.777,3.675C0.219,3.824-0.113,4.398,0.035,4.957l7.224,26.954 c0.15,0.562,0.726,0.891,1.282,0.741l12.832-3.438c1.413,2.264,3.92,3.775,6.779,3.775c1.242,0,2.415-0.293,3.465-0.799 l0.004,0.026l2.714,4.12c0.201,0.306,0.54,0.477,0.883,0.477c0.199,0,0.397-0.063,0.582-0.176 C36.288,36.322,36.425,35.662,36.101,35.172z M20.197,5.466l-3.063,0.821l-0.822-3.07L20.197,5.466z M9.018,30.354L2.34,5.429 L13.904,2.33l1.476,5.508c0.152,0.566,0.726,0.901,1.281,0.752l5.514-1.478l2.821,10.53c-2.843,1.228-4.839,4.059-4.839,7.352 c0,0.794,0.12,1.561,0.336,2.284L9.018,30.354z M28.153,30.99c-3.308,0-5.996-2.688-5.996-5.997c0-3.312,2.688-6.003,5.996-6.003 c3.309,0,6.004,2.691,6.004,6.003C34.157,28.303,31.462,30.99,28.153,30.99z"
}));

var SvgSolicitudRevisarIcon = function SvgSolicitudRevisarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    enableBackground: "new 0 0 37 37",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSolicitudRevisarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/solicitudRevisar_icon.32d73d52.svg";
export { ForwardRef as ReactComponent };